module.exports = __webpack_public_path__ + "static/media/U1-T1-2-3.60eed362.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/U1-T1-2-3.mp4
// module id = 523
// module chunks = 0